export const homepage = {
    first_screen_title: '<h1>Ahead</h1>\n<h1>of <strong>climate</strong> change.</h1>',
    fs_title_background: null,
    description:
        '<p>Finding new solutions to <strong>meet the challenges </strong>of agribusiness in times of climate change</p>',
    banner_title:
        '<p>We offer solutions that can respond to <strong>future climate change</strong> and related challenges.</p>',
    banner_cards: [
        {
            title: '22+',
            text: 'years in agricultural industry',
            icon: 'https://api-uniferx.goodface.com.ua/storage/homepage/variant1.svg',
        },
        {
            title: '>150',
            text: 'conducted research with our products',
            icon: 'https://api-uniferx.goodface.com.ua/storage/homepage/folder.svg',
        },
        {
            title: '15 ',
            text: 'partners in various countries',
            icon: 'https://api-uniferx.goodface.com.ua/storage/homepage/agricultureIcon.svg',
        },
        {
            title: '95%',
            text: ' increase yields with our solutions',
            icon: 'https://api-uniferx.goodface.com.ua/storage/homepage/plants.svg',
        },
    ],
    about_tag: 'ABOUT US',
    about_title:
        '<p>A family business philosophy<br /><strong>born in <img src="https://api-uniferx.goodface.com.ua/storage/shares/EuropeFlag.jpg" alt="" width="360" height="160" />&nbsp;Europe</strong>, with solutions&nbsp;<strong>made in <img src="https://api-uniferx.goodface.com.ua/storage/shares/GermanFlag.jpg" alt="" width="360" height="160" />&nbsp;Germany</strong></p>',
    about_text: null,
    about_button: 'Learn more about us',
    mission_title: 'Ensuring safer harvests in an unsafer environment ',
    mission_background_image: 'https://api-uniferx.goodface.com.ua/storage/Mission & values - Image.jpg',
    mission_cards: [
        {
            title: null,
            text: 'We at UniferX cannot revert climate change, but we can help to change its impact on agriculture, thereby ensuring a safer supply of crops and food - for today as well as tomorrow.',
        },
        {
            title: null,
            text: 'At UniferX, we strive to combine the qualities of a responsible, dynamic international company with originality and uniqueness with the benefits of a family business philosophy - a philosophy guided by European values and solutions made in Germany.',
        },
        {
            title: null,
            text: 'We offer intelligent solutions that enable plants to adapt to constantly changing climatic and environmental conditions. High-performance, environmentally friendly products and technologies for agriculture, inspired by nature and respecting nature.',
        },
    ],
    products_tag: 'Products',
    products_title:
        '<p><span class="black-text"><strong>Our products</strong> <br />are more than just fertilizers</span></p>',
    discover_title: 'Discover our <b>trial results & crop nutrition programs</b>',
    discover_trial_image: 'https://api-uniferx.goodface.com.ua/storage/Chart Illustration.png',
    discover_trial_title: 'Trial results',
    discover_trial_description:
        'Here you can find our trial results and\nconclusions on the effectiveness of our\nproducts in increasing yields.',
    discover_nutrition_background: 'https://api-uniferx.goodface.com.ua/storage/brunoMartins.jpg',
    discover_nutrition_title: 'Crop nutrition programs',
    discover_nutrition_description:
        'Learn how to care for your plants, providing them with proper nutrition for maximum crop yield and health.\n\n',
    discover_information_title: 'Information materials',
    discover_information_description:
        'Check out our product catalogs, which contain detailed information on composition and application in PDF format.',
    news_tag: 'Stay up to date',
    news_title: 'Latest research, news & events',
    news_description:
        "<p>We're constantly&nbsp;<strong>publishing fresh news and research</strong>, that will help expand your knowledge of the current&nbsp;<strong>challenges in the agricultural industry.</strong></p>",
    news_button: 'VIEW ALL NEWS',
    instagram_title: 'Follow our news on Instagram',
    instagram_photo_1: 'https://api-uniferx.goodface.com.ua/storage/instagram/instagramImage1.png',
    instagram_photo_2: 'https://api-uniferx.goodface.com.ua/storage/instagram/instagramImage2.jpg',
    instagram_photo_3: 'https://api-uniferx.goodface.com.ua/storage/instagram/instagramImage3.png',
    instagram_photo_4: 'https://api-uniferx.goodface.com.ua/storage/instagram/instagramImage4.jpg',
};

export const mainProducts = [
    {
        slug: 'organic_line',
        type: 'product',
        preview_title: 'Organic line',
        preview_image: 'https://api-uniferx.goodface.com.ua/storage/products/Organic line.jpg',
        logo: 'https://api-uniferx.goodface.com.ua/storage/products/product-logo-with-blur-1.svg',
        preview_description:
            'Betino® and VeganoХ® is approved by FiBL and Organic Standard for use in organic farming without restrictions. It is a reliable solution for increasing plant resistance to osmotic and oxidative stress.',
        preview_button_text: 'View product',
    },
    {
        slug: 'wuxal',
        type: 'product',
        preview_title: 'Wuxal',
        preview_image: 'https://api-uniferx.goodface.com.ua/storage/products/Wuxal.jpg',
        logo: 'https://api-uniferx.goodface.com.ua/storage/products/product-logo-with-blur-2.svg',
        preview_description:
            'Wuxal® — is an effective suspension for foliar treatment of plants and seed treatment, as well as a set of innovative solutions that allow you to achieve high efficiency.',
        preview_button_text: 'View product',
    },
    {
        slug: 'fertiplant',
        type: 'product',
        preview_title: 'Fertiplant',
        preview_image: 'https://api-uniferx.goodface.com.ua/storage/products/Fertiplant.jpg',
        logo: 'https://api-uniferx.goodface.com.ua/storage/products/product-logo-with-blur-3.svg',
        preview_description:
            'With Fertiplant® fertilizers, you can fully rely on the impeccable quality of the product and its optimal properties.',
        preview_button_text: 'View product',
    },
    {
        slug: 'uniferx',
        type: 'product',
        preview_title: 'UniferX',
        preview_image: 'https://api-uniferx.goodface.com.ua/storage/products/UniferX.jpg',
        logo: 'https://api-uniferx.goodface.com.ua/storage/products/product-logo-with-blur-4.svg',
        preview_description:
            'UniferX is a high quality fine crystalline fertilizer for foliar feeding. It is designed to quickly eliminate or prevent manganese deficiency in plants.',
        preview_button_text: 'View product',
    },
];
